import { featuredLead, heroGuide } from "@/mocks/guatian";

const guideIcon = ["ri-git-branch-line", "ri-arrow-left-right-line", "ri-flashlight-fill", "ri-fire-fill"];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-background-200 bg-background-100/60">
      {/* 装饰圆点 */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full opacity-60"
        style={{ background: "radial-gradient(circle at center, oklch(var(--primary-200)) 0%, transparent 70%)" }}
      ></div>
      <div className="relative mx-auto grid max-w-[1280px] gap-10 px-4 pb-12 pt-10 md:px-6 lg:grid-cols-[1.25fr_1fr] lg:gap-14 lg:pb-16 lg:pt-14">
        <div className="gt-fade-up">
          <div className="inline-flex items-center gap-2 rounded-full bg-accent-500/10 px-3 py-1.5 text-xs font-bold text-accent-700">
            <i className="ri-pen-nib-line" aria-hidden="true"></i>
            {featuredLead.kicker}
            <span className="h-1 w-1 rounded-full bg-accent-500/50"></span>
            <span className="font-normal text-accent-600">编辑部 · 每日一期</span>
          </div>

          <h1 className="mt-5 text-3xl font-bold leading-[1.25] tracking-tight text-foreground-950 md:text-[44px] md:leading-[1.18]">
            {featuredLead.title}
          </h1>

          <p className="mt-5 max-w-2xl text-base leading-7 text-foreground-600">
            {featuredLead.summary}
          </p>

          <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-sm text-foreground-600">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-time-line text-primary-600" aria-hidden="true"></i>更新于 2026-09-08 12:38
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-fire-line text-accent-600" aria-hidden="true"></i>热度 98 · 实时上升
            </span>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#updates"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-3 text-sm font-bold text-background-50 transition hover:bg-primary-700"
            >
              查看完整跟进
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
            <a
              href="#timeline"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-bold text-foreground-800 transition hover:border-primary-300 hover:text-primary-700"
            >
              事件时间线
            </a>
          </div>

          <div className="mt-8 grid gap-2.5 border-t border-background-200 pt-6 sm:grid-cols-1">
            {featuredLead.points.map((p) => (
              <div key={p} className="flex items-center gap-3 text-sm text-foreground-700">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-check-line text-xs" aria-hidden="true"></i>
                </span>
                {p}
              </div>
            ))}
          </div>
        </div>

        <div className="gt-fade-up grid grid-cols-2 gap-4 self-center" style={{ animationDelay: "0.12s" }}>
          {heroGuide.map((g, i) => (
            <a
              key={g.n}
              href={`#${["updates", "reversal", "updates", "columns"][i]}`}
              className="group rounded-lg border border-background-200 bg-background-50 p-5 transition hover:-translate-y-1 hover:border-primary-300"
            >
              <span className="text-xs font-black tracking-widest text-background-400">/{g.n}</span>
              <div className="mt-2 flex items-center justify-between">
                <span
                  className="text-2xl font-bold text-foreground-950 group-hover:text-primary-700"
                  style={{ fontFamily: "var(--font-heading)" }}
                >
                  {g.t}
                </span>
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-lg text-primary-600 group-hover:bg-primary-600 group-hover:text-background-50">
                  <i className={guideIcon[i]} aria-hidden="true"></i>
                </span>
              </div>
              <p className="mt-2 text-xs leading-5 text-foreground-500">{g.d}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}